// extracted by mini-css-extract-plugin
export default {"success":"index_success_UKi0o","successBox":"index_successBox_LsCY1","successCallback":"index_successCallback_KEB1v"};